let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55GNU")).then(() => parcelRequire('7lmhQ'));